import { render, staticRenderFns } from "./CompanyPatternCard.vue?vue&type=template&id=45e3db2a&"
import script from "./CompanyPatternCard.vue?vue&type=script&lang=js&"
export * from "./CompanyPatternCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports